module.exports = __webpack_public_path__ + "img/mithrillongsword.eb419336.png";